import { alpha, Theme } from '@material-ui/core/styles';

// ----------------------------------------------------------------------
type BackdropReturn = {
  MuiBackdrop: { styleOverrides: { root: { background: string[]; '&.MuiBackdrop-invisible': { background: string; }; }; }; };
}
export const Backdrop = (theme: Theme): BackdropReturn => {
  const varLow = alpha(theme.palette.grey[900], 0.48);
  const varHigh = alpha(theme.palette.grey[900], 1);

  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          background: [
            'rgb(22,28,36)',
            `-moz-linear-gradient(75deg, ${varLow} 0%, ${varHigh} 100%)`,
            `-webkit-linear-gradient(75deg, ${varLow} 0%, ${varHigh} 100%)`,
            `linear-gradient(75deg, ${varLow} 0%, ${varHigh} 100%)`,
          ],
          '&.MuiBackdrop-invisible': {
            background: 'transparent',
          },
        },
      },
    },
  };
};
